import styled from "styled-components";
import { useState, forwardRef, useRef, useImperativeHandle } from "react";
import { Dialog, DialogTitle, DialogActions, Button, DialogContent, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import MuiBlock from '../atom/MuiCustoms';
import StyledButton from '../atom/Button';
import LuckyNumberAgreementAcceptButton from "./LuckyNumberAgreementAcceptButton";
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

const CustomDialog = styled(Dialog)`
    .MuiDialog-container > .MuiPaper-root {
        width: 100%;
        max-width: 80rem;
        overflow: hidden;
    }

    &.isSuccess .MuiDialog-container > .MuiPaper-root {
        max-width: 30rem;
    }

    .MuiDialogTitle-root {
        display: flex;
        gap: 1rem;
        align-items: center;

        & > span {
            flex: 1;
        }

        .MuiButtonBase-root {
            color: var(--color-gray) !important;
        }
    }

    .MuiDialogActions-root {
        justify-content: center;
        padding: 1rem .5rem;
        gap: 1rem;
    }

    .agreementFrame {
        width: 100%;
        height: 70vh;
        display: flex;
    }

    .successBlock {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        min-height: 15rem;

        .MuiSvgIcon-root {
            font-size: 6rem;
        }
    }
`;

const LuckyNumberAgreementModal = forwardRef(({promoId, agreementData, reload, style}, ref) => {
    const innerRef = useRef();
    const [open, setOpened] = useState(false);
    const [successMode, setSuccessMode] = useState(false);
    const [acceptMode, setAcceptMode] = useState(false);
    const documentUrl = agreementData.urlDocument || null;

    const handleClose = () => {
        setOpened(false);
        if(successMode && reload) {
            reload();
        }
    };

    const handleSuccess = () => {
        setSuccessMode(true);
    }

    const handleDocumentDownload = () => {
        window.open(documentUrl, '_blank');
    }

    useImperativeHandle(ref, () => ({
        openAgreement: () => {
            setAcceptMode(false);
            setOpened(true);
        },
        openAgreementAccept: () => {
            setAcceptMode(true);
            setOpened(true);
        },
        closeDialog: () => {
            setOpened(false);
        }
    }));

    return (
        <MuiBlock style={style}>
            <CustomDialog
                ref={innerRef}
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className={successMode ? 'isSuccess' : ''}
            >
                <DialogTitle id="alert-dialog-title">
                    <span>
                        {acceptMode && <>Participar da campanha</>}
                        {!acceptMode && <>Regulamento</>}
                    </span>
                    {!successMode && documentUrl !== null && <IconButton aria-label="Download" title="Download" onClick={() => handleDocumentDownload()} color="secondary"><FileDownloadOutlinedIcon /></IconButton>}
                    <IconButton  onClick={() => handleClose()} title="Fechar" aria-label="Fechar" color="secondary"><CloseIcon /></IconButton>
                </DialogTitle>
                <DialogContent style={{padding: 0}}>
                    {!successMode && documentUrl !== null && <iframe className='agreementFrame' title='Regulamento' src={documentUrl} style={{border: 0}}></iframe>}
                    {successMode && (
                        <div className="successBlock">
                            <ThumbUpOutlinedIcon fontSize="large" color="primary"/>
                            <strong>Participação confirmada</strong>
                            <Button onClick={() => handleClose()} variant="outlined">Fechar</Button>
                        </div>
                    )}
                </DialogContent>
                {acceptMode && !successMode && (
                    <DialogActions style={{borderTop: '1px solid var(--color-lightGray'}}>
                        <StyledButton onClick={() => handleClose()} className="secondary" style={{border: 'none'}}>Cancelar</StyledButton>
                        <LuckyNumberAgreementAcceptButton style={{minWidth: '10rem'}} promoId={promoId} callback={handleSuccess}>Aceitar</LuckyNumberAgreementAcceptButton>
                    </DialogActions>
                )}
            </CustomDialog>
        </MuiBlock>
    )
});

export default LuckyNumberAgreementModal;